import React, { Component } from 'react';
import StraightLine from '../../../../../img/ComponentAsImage/StraightLine';
import DashLine from '../../../../../img/ComponentAsImage/DashLine.js';
import DottedLine from '../../../../../img/ComponentAsImage/DottedLine.js';
import {
  NUMBER_OF_ORDERED_TOPICS,
  TOPIC_TITLE_CLASS,
  TITLES_WITH_LINE_TYPES_CLASS,
} from '../../constants/TitlesWithLineTypesConstants';

class TitlesWithLineTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      color: this.props.color,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      color: nextProps.color,
    });
  }

  renderLineTypes(index) {
    switch (index) {
      case NUMBER_OF_ORDERED_TOPICS.FIRST:
        return <StraightLine stroke={this.state.color} />;
      case NUMBER_OF_ORDERED_TOPICS.SECOND:
        return <DashLine stroke={this.state.color} />;
      case NUMBER_OF_ORDERED_TOPICS.THIRD:
        return <DottedLine stroke={this.state.color} />;
      default:
        return <React.Fragment></React.Fragment>;
    }
  }

  renderTitlesWithLineTypes() {
    const { selectedTopicNamesToCompare } = this.props;
    return (
      <div>
        {selectedTopicNamesToCompare.map((item, index) => (
          <div className={TITLES_WITH_LINE_TYPES_CLASS} key={item}>
            {this.renderLineTypes(index)}
            <p className={TOPIC_TITLE_CLASS}>{item}</p>
          </div>
        ))}
      </div>
    );
  }

  render() {
    return this.renderTitlesWithLineTypes();
  }
}

export default TitlesWithLineTypes;



// WEBPACK FOOTER //
// ./src/features/home/components/compare/chart/TitlesWithLineTypes.js